export type AiAskSearchIndexBlock = {
  index: string;
  object_ids: string[];
  count: number | null;
};

type AiAskSearchDataForNormalization = {
  indexes: unknown;
  count: number | null;
  object_ids?: string[] | null;
};

function parseIndexBlock(value: unknown): AiAskSearchIndexBlock | null {
  if (!value || typeof value !== 'object') return null;

  const block = value as Record<string, unknown>;
  const index = String(block.index ?? '')
    .trim()
    .toLowerCase();
  if (!index) return null;

  const objectIds = Array.isArray(block.object_ids)
    ? block.object_ids.map((id) => String(id)).filter(Boolean)
    : [];

  const countRaw = block.count;
  const count =
    countRaw == null || countRaw === ''
      ? null
      : Number.isFinite(Number(countRaw))
      ? Number(countRaw)
      : null;

  return { index, object_ids: objectIds, count };
}

function parseLegacySingleIndex(
  index: string,
  searchData: AiAskSearchDataForNormalization
): AiAskSearchIndexBlock[] {
  return [
    {
      index: index.trim().toLowerCase(),
      object_ids: Array.isArray(searchData.object_ids)
        ? searchData.object_ids.map((id) => String(id))
        : [],
      count: searchData.count,
    },
  ];
}

export function normalizeIndexBlocks(
  searchData: AiAskSearchDataForNormalization
): AiAskSearchIndexBlock[] {
  const rawIndexes: unknown = searchData.indexes;

  if (rawIndexes == null) {
    return [];
  }

  if (Array.isArray(rawIndexes)) {
    return rawIndexes
      .map(parseIndexBlock)
      .filter((block): block is AiAskSearchIndexBlock => Boolean(block));
  }

  if (typeof rawIndexes === 'string' && rawIndexes.trim()) {
    return parseLegacySingleIndex(rawIndexes, searchData);
  }

  return [];
}
